
import { BaseComponent } from '@/decorators';
import api from '@/utils/api';
import { Component } from 'vue-property-decorator';
import {columns} from './index'
import WorkFormModal from './Form.vue'
@Component({
    components:{ WorkFormModal }
})
export default class WorkFormIndex extends BaseComponent{
    
    OVC(e:boolean){
        if (e){
        }else{
            this.Init();
            this.Readonly = false;
        }
    }

    
    Readonly = false;
    List = new Array<any>();
    Columns = [...columns];
    

    async mounted(){
        await this.Init();
        await this.FetchData();
    }
    async  FetchData() {
        let res = await api.WorkForm.Query(this.Pager, this.Query);
        if (res.status == 200) {
            this.List = [...res.data.data];
            this.Pager.total = res.data.count;
        }
    }
    
    ShowModal(row: any,isReadonly:boolean) {
        this.Row = { ...row };
        this.Readonly = isReadonly;
        this.OpenModal();
    }
    OpenModal() {
        this.$refs.PageView.showModal = true;
    }

    async Init() {
        this.$refs.Modal.Clear();
        this.$refs.PageView.showModal = false;
        this.Row = null;
        this.Query = { name: '', phone: '' };
        this.InitPager();
    }

    async Save() {
        let res:any = null; 
        let payload = { ...this.$refs.Modal.Model ,isDeleted: this.$refs.Modal.Model.isDeleted == 1 };
        if (this.Row && !this.Readonly)
            res = await api.WorkForm.Edit(payload);
        else 
            res = await api.WorkForm.Create(payload);
        if (res.status == 200) {
            this.$Notice.success({ title:this.Row?'修改成功!':'添加成功!' });
            await this.Init();
            await this.FetchData();
        }
    }

    async Remove(id: number) {
        this.$Modal.confirm({
            title: '删除确认',
            content: '确认要删除选择的流程信息吗？',
            onOk: async () => {
                let res = await api.WorkForm.Delete(id);
                if (res.status == 200 && res.data) {
                    await this.Init();
                    await this.FetchData();
                    this.$Notice.success({ title: '删除成功' });
                } else {
                    this.$Notice.error({ title: '删除失败' });
                }

            }
        });
    }
}
